import React, { useEffect, useState } from 'react';
import { Outlet, NavLink, useNavigate, useSearchParams } from 'react-router-dom';
import { authApi } from '../../helpers/auth';
import {
  Folder,
  Calendar,
  Briefcase,
  BookOpen,
  Newspaper,
  Bell,
  Settings,
  Image,
  Users,
  LogOut,
  LayoutDashboard,
  PanelBottom,
  FileText
} from 'lucide-react';

const DEV_MODE_KEY = 'admin_dev_mode';

const AdminLayout = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const user = authApi.getUser();
  const [devMode, setDevMode] = useState(() => sessionStorage.getItem(DEV_MODE_KEY) === '1');

  useEffect(() => {
    if (searchParams.get('mode') === 'dev') {
      sessionStorage.setItem(DEV_MODE_KEY, '1');
      setDevMode(true);
    }
  }, [searchParams]);

  const handleLogout = () => {
    if (window.confirm('Êtes-vous sûr de vouloir vous déconnecter ?')) {
      authApi.logout();
      sessionStorage.removeItem(DEV_MODE_KEY);
      navigate('/admin');
    }
  };

  const menuItems = [
    { path: '/admin/dashboard', label: 'Tableau de bord', icon: LayoutDashboard },
    { path: '/admin/events', label: 'Évènements', icon: Calendar },
    { path: '/admin/patrimoine-actualites', label: 'Patrimoine & Actualités', icon: Newspaper },
    { path: '/admin/popups', label: 'Popups', icon: Bell },
    { path: '/admin/collections', label: 'Collections', icon: Folder },
    { path: '/admin/hiring-ads', label: 'Vie administrative', icon: Briefcase },
    { path: '/admin/magazines', label: 'Magazines', icon: BookOpen },
    { path: '/admin/menu-page', label: 'Page Exposition', icon: Image },
    { path: '/admin/footer', label: 'Footer', icon: PanelBottom, devOnly: true },
    { path: '/admin/pages', label: 'Pages statiques', icon: FileText, devOnly: true },
    { path: '/admin/settings', label: 'Informations', icon: Settings },
    { path: '/admin/users', label: 'Utilisateurs', icon: Users },
  ];

  return (
    <div className="container-fluid">
      <div className="row">
        {/* Sidebar */}
        <div className="col-md-3 col-lg-2 sidebar bg-dark text-white p-0 vh-100">
          <div className="p-3 border-bottom">
            <h5 className="mb-0">Administration</h5>
            <small className="text-secondary">{user?.email}</small>
          </div>
          
          <nav className="nav flex-column p-2">
            {menuItems.filter(item => !item.devOnly || devMode).map((item) => {
              const IconComponent = item.icon;
              return (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className={({ isActive }) => 
                    `nav-link text-white d-flex align-items-center py-2 px-3 rounded ${
                      isActive ? 'bg-primary' : 'text-decoration-none'
                    }`
                  }
                >
                  <IconComponent size={18} className="me-2" />
                  {item.label}
                </NavLink>
              );
            })}
          </nav>
          
          <div className="mt-auto p-3">
            <button
              className="btn btn-outline-light btn-sm w-100 d-flex align-items-center justify-content-center"
              onClick={handleLogout}
            >
              <LogOut size={16} className="me-2" />
              Déconnexion
            </button>
          </div>
        </div>

        {/* Main Content */}
        <div className="col-md-9 col-lg-10">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;